import { makeAutoObservable } from 'mobx';
import type { ExpertDefaults } from '../types/expert';
import { authService } from '../api/services/authService';
import type { AuthConstants } from '../types/user';
import { configService } from '../api/services/configService';

class ConstantsStore {
  expertConstants: ExpertDefaults | null = null;
  isExpertConstantsLoading = false;
  setIsExpertConstantsLoading = (value: boolean) => (this.isExpertConstantsLoading = value);

  authConstants: AuthConstants | null = null;
  isAuthConstantsLoading = false;
  setIsAuthConstantsLoading = (value: boolean) => (this.isAuthConstantsLoading = value);

  googleServiceEmail: string | null = null;

  setExpertConstants = (v: ExpertDefaults | null) => (this.expertConstants = v);

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async initExpertConstants() {
    try {
      this.setIsExpertConstantsLoading(true);
      const { data } = await configService.getExpertConstants();
      this.setExpertConstants(data.json);
    } catch (error) {
      console.error(error);
    } finally {
      this.setIsExpertConstantsLoading(false);
    }
  }

  async initAuthConstants() {
    try {
      this.setIsAuthConstantsLoading(true);
      const { data } = await authService.getAuthConfig();
      this.authConstants = data.json;
    } catch (error) {
      console.error(error);
    } finally {
      this.setIsAuthConstantsLoading(false);
    }
  }

  async initGoogleServiceEmail() {
    try {
      const { data } = await configService.getServiceEmail();
      this.googleServiceEmail = data;
    } catch (error) {
      console.error(error);
    }
  }
}

export const constantsStore = new ConstantsStore();
